import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const CoverSection = () => (
  <View id="4">
    <Text bold size="small">
      3. OBJETIVOS
    </Text>

    <ul>
      <li>
        <Text>
          Preservar a saúde e integridade dos trabalhadores, através da antecipação, reconhecimento, avaliação e
          controle da ocorrência de riscos ergonômicos existentes ou que venham a existir no ambiente de trabalho.
        </Text>
      </li>

      <li>
        <Text>
          Atender o disposto na Norma Regulamentadora nº. 17 - Ergonomia, aprovada pela Portaria 426, DE 7 DE OUTUBRO DE
          2021 / STRAB n°. 3.214/78.
        </Text>
      </li>

      <li>
        <Text>
          Otimizar a Gestão de Segurança e Saúde Ocupacional da Unimed, através das ações de identificação, análise,
          avaliação, adaptação e controle dos agentes de riscos ergonômicos presentes nos ambientes e postos de
          trabalho.
        </Text>
      </li>

      <li>
        <Text>
          Estabelecer parâmetros que permitam a adaptação das condições de trabalho às características psicofisiológicas
          dos funcionários, de modo a proporcionar um máximo de conforto, segurança e desempenho eficiente no trabalho.
        </Text>
      </li>

      <li>
        <Text>
          Analisar as atividades desenvolvidas pelos funcionários quanto a levantamento, transporte e descarga de
          materiais, mobiliário, equipamento, condições ambientais do posto de trabalho e a própria organização do
          trabalho.
        </Text>
      </li>

      <li>
        <Text>
          Apresentar aos funcionários os riscos ergonômicos inerentes às atividades da Unimed e as medidas de controle
          para mantê-los em níveis seguros para a saúde e bem-estar dos seus trabalhadores
        </Text>
      </li>
    </ul>

    <Separator weight={8} />
  </View>
)

export default CoverSection
